import moment from "moment";

export const toLocalFormat = (date: string | Date) => {
  return moment(date).format("YYYY-MM-DDTHH:mm");
};
